<template>
  <div class="pc-userlist">
    <BreadCrumb :data="breadCrumb" :title="'用户列表'" />

    <div class="pc-userlist-draw">
      <div class="pc-userlist-draw-tables">
        <TableUserCount :userStatisticses="userStatisticses" ref="TableUserCount" />
      </div>
      <div class="pc-userlist-draw-charts">
        <ChartUserVitality
          class="charts-vitality"
          :userStatisticses="userStatisticses"
        />
      </div>
    </div>

    <div class="AgeAndSex">
      <h1>活跃用户成分比例</h1>
      <AgeAndSex :userStatisticses="userStatisticses.activate_user_map"  class="main" />
    </div>
    <UserTable />
    <p class="pc-userlist-copyright">copyright©-<span>wupen.org</span></p>
  </div>
</template>



<script>
import AgeAndSex from "./userList/AgeAndSex";

import UserTable from "./userList/UserTable";
import TableUserCount from "./userList/TableUserCount";
import ChartUserVitality from "./userList/ChartUserVitality";
import BreadCrumb from "../../componentSet/BreadCrumb.vue";

import { getGroupPortrait_Api } from "../../../apis/statistics.api";
export default {
  components: {
    BreadCrumb,
    ChartUserVitality,
    TableUserCount,
    UserTable,
    AgeAndSex,
  },
  computed: {
    breadCrumb() {
      return [
        { name: "首页", link: "/admin/main" },
        { name: "用户管理", link: "/admin/userlist" },
       
      ];
    },
  },
  data() {
    return {
      userStatisticses: {},
    };
  },
  created() {
    this.getUserStatisticses();
  },
  methods: {
    getUserStatisticses() {
      console.log(123);
      getGroupPortrait_Api({}).then((res) => {
        console.log(res);
        this.userStatisticses = res;
      });
    },
  },
};
</script>



<style lang="scss" scoped>
.pc-userlist {
  .pc-userlist-draw {
    display: flex;
    margin: 40px 0px;
    justify-content: space-between;
    .pc-userlist-draw-charts {
      width: calc(100% - 360px);
      margin-left: 25px;
      display: flex;
      .charts-mistress {
        min-width: 25px;
      }
      .charts-vitality,
      .charts-count {
        width: 100%;
      }
    }
  }

  .AgeAndSex {
    // width: 800px;
    padding: 40px 30px 0 30px;
    justify-content: space-between;
    overflow: hidden;
    border-radius: 4px;
    box-shadow: $shadowCard;
    h1 {
      padding-bottom: 20px;
      border-bottom: 1px solid #c0c0c0;
      font-family: $chinese;
      font-size: 20px;
      font-weight: bold;
      color: $mainTitle;
    }
    .main {
      min-width: 300px;
      display: flex;
      justify-content: space-between;
    }
  }

  .pc-userlist-copyright {
    text-align: center;
    margin-top: 50px;
    font-family: $chinese;
    font-size: 14px;
    color: #434343;
    span {
      color: $timeBtn;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/admin/userManagement/userList.vue